<mf-page title="Configuración">
  @if (configurationDto()){
  <mf-configuration [configurationDto]="configurationDto()!"></mf-configuration>
  }
</mf-page>
